document.addEventListener("DOMContentLoaded", function (event) {
  // mega menu
   // mega menu - 处理所有 yg-mega-menu-nav 容器
   const megaNavs = document.querySelectorAll(".yg-mega-menu-nav");

   megaNavs.forEach((nav) => {
     const megaList = nav.querySelectorAll(".yg-mega-menu-li .yg-mega-menu-alink");
     const megaMenu = [];
 
     // 为每个菜单项找到对应的子菜单
     megaList.forEach((item) => {
       const parentLi = item.closest('.yg-mega-menu-li');
       const subMenu = parentLi ? parentLi.querySelector('.yg-mega-sub-link') : null;
       megaMenu.push(subMenu);
     });
 
     // 为当前容器的菜单项添加事件监听
     megaList.forEach((item, index) => {
       item.addEventListener("mouseover", function () {
         setActive(nav, megaList, megaMenu, index);
       });
     });
 
     // 默认激活当前容器的第一个菜单项
     if (megaList.length > 0) {
       setActive(nav, megaList, megaMenu, 0);
     }
   });
 
   function setActive(nav, megaList, megaMenu, index) {
     // 只在当前容器内移除 active 类
     megaList.forEach((listItem) => listItem.classList.remove("active"));
     megaMenu.forEach((menu) => {
       if (menu) menu.classList.remove("active");
     });
 
     // 激活当前索引的菜单项和子菜单
     megaList[index].classList.add("active");
     if (megaMenu[index]) {
       megaMenu[index].classList.add("active");
     }
   }

  // mega menu

  // 产品变体分类图
  let $coloGroups = Array.from(document.querySelectorAll(".yg-variant-color-option label"));
  if ($coloGroups.length === 0) {
    const firstOption = document.querySelector(".product-info__variant-picker variant-picker .variant-picker__option");
    if (firstOption) {
      $coloGroups = Array.from(firstOption.querySelectorAll("label"));
    }
  }
  const $variantGroupBox = Array.from(document.querySelectorAll(".yg-variant-picker-group img"));
  const $variantGroupLabel = Array.from(document.querySelectorAll(".yg-variant-row-option .variant-picker__option-values label"));

  $coloGroups.forEach((label) => {
    label.addEventListener("click", function () {
      const value = label.getAttribute('data-value').trim();
      if (!value) return;
      const matchedImages = $variantGroupBox.filter(img => {
        const title = img.getAttribute("data-title")?.trim() || "";
        if (!title) return false;

        if (value.includes("/")) {
          return title.trim().startsWith(value);
        } else {
          const parts = title.split("/").map(part => part.trim());
          return parts.includes(value);
        }
      });

      $variantGroupLabel.forEach((variantLabel) => {
        const variantValue = variantLabel.getAttribute("data-value")?.trim();
        if (!variantValue) return;

        const imagesToAdd = matchedImages.filter(img => {
          const title = img.getAttribute("data-title") || "";
          const parts = title.split("/").map(part => part.trim());
          return parts.includes(variantValue);
        });


        const oldImg = variantLabel.querySelector("img");
        if (oldImg) oldImg.remove();

        if (imagesToAdd.length) {
          const newImg = imagesToAdd[0].cloneNode(true);
          variantLabel.appendChild(newImg);
        }
      });
    });
  });


  // 产品变体分类
  // const $coloGroup = Array.from(document.querySelectorAll(".yg-variant-color-option label"));
  // const $rowGroup = Array.from(document.querySelectorAll(".yg-variant-row-option label"));

  // function filterRowGroup(labelValue, isInitialLoad = false) {
  //     const lowercasedLabelValue = labelValue.toLowerCase();
  //     let firstMatchFound = false;
  //     $rowGroup.forEach(rowLabel => {
  //         const $rowValue = rowLabel.getAttribute("data-value").toLowerCase();
  //         if (!$rowValue.includes(lowercasedLabelValue)) {
  //             rowLabel.classList.add("hidden");
  //         } else {
  //             rowLabel.classList.remove("hidden");

  //             if (!firstMatchFound && !isInitialLoad) {
  //                 rowLabel.click();
  //                 firstMatchFound = true;
  //             }
  //         }
  //     });
  // }

  // if ($coloGroup.length > 0) {
  //     $coloGroup.forEach(label => {
  //         label.addEventListener("click", () => {
  //             const $labelValue = label.getAttribute("data-value");
  //             filterRowGroup($labelValue);
  //         });
  //     });
  // }

  // const defaultCheckedInput = document.querySelector(".yg-variant-color-option input:checked");
  // if (defaultCheckedInput) {
  //     const defaultLabel = defaultCheckedInput.nextElementSibling;
  //     const defaultLabelValue = defaultLabel.getAttribute("data-value");
  //     filterRowGroup(defaultLabelValue, true);
  // }

  // let defaultCheckedCheckbox = document.querySelector('.yg-variant-additional-option input[type="radio"]:checked');
  // let isCurrentlyChecked = true;

  // defaultCheckedCheckbox.addEventListener('click', function (event) {
  //     const allCheckboxes = document.querySelectorAll('.yg-variant-additional-option input[type="radio"]');
  //     let otherCheckbox = null;

  //     for (const checkbox of allCheckboxes) {
  //         if (checkbox !== event.target) {
  //             otherCheckbox = checkbox;
  //             break;
  //         }
  //     }

  //     if (isCurrentlyChecked) {
  //         if (otherCheckbox) {
  //             if (otherCheckbox.nextElementSibling) {
  //                 const event = new MouseEvent('click', {
  //                     bubbles: true, cancelable: true, view: window
  //                 });
  //                 otherCheckbox.nextElementSibling.dispatchEvent(event);
  //             }
  //         }
  //         defaultCheckedCheckbox = false;
  //         isCurrentlyChecked = false;
  //     } else {
  //         event.target.checked = true;
  //         defaultCheckedCheckbox = true;
  //         isCurrentlyChecked = true;
  //         event.target.nextElementSibling.click();
  //         if (otherCheckbox) {
  //             otherCheckbox.checked = false;
  //         }
  //     }
  // });

  // class YgAdditionalCheckbox extends HTMLElement {
  //     constructor() {
  //         super();
  //         this.attachEvents();
  //     }
  //
  //     attachEvents() {
  //         const checkbox = this.querySelector('.yg-additional-input');
  //         const additionalInputProperties = document.querySelector('.yg-additional-input-properties');
  //         const additionalText = this.querySelector('.yg-additional-text');
  //         const activePrice = this.querySelector('.additional-price.active');
  //
  //         if (checkbox && additionalInputProperties) {
  //             checkbox.addEventListener('change', () => {
  //                 if (checkbox.checked) {
  //                     const infoPrice = activePrice ? activePrice.getAttribute('data-info-price') : '';
  //
  //                     const textContent = additionalText ? additionalText.textContent : '';
  //
  //                     additionalInputProperties.value = infoPrice;
  //
  //                     additionalInputProperties.name = `properties[${textContent}]`;
  //                 } else {
  //                     additionalInputProperties.value = '';
  //                     additionalInputProperties.name = 'properties[additional]';
  //                 }
  //             });
  //         }
  //     }
  // }

  // if (!window.customElements.get("yg-additional-checkbox")) {
  //     customElements.define('yg-additional-checkbox', YgAdditionalCheckbox);
  // }
});

// 变体插件变体组
// window.onload = function () {
//   let ygOption = document.querySelector(".yg-option-color");
//   if (ygOption) {
//     const optionBtn = ygOption.querySelectorAll("input + div");
//     const optionInput = ygOption.querySelectorAll("input");
//     const productGallery = document.querySelector("product-gallery");
//     const scrollShadow = document.querySelectorAll(
//       "product-gallery scroll-shadow",
//     );
//     const pageDots = document.querySelector("product-gallery page-dots");
//     const thumbNail = document.querySelectorAll(
//       "product-gallery .product-gallery__thumbnail",
//     );
//     const optionBtns = document.querySelectorAll('.mw-option:not(.yg-option-color) .mw-stack__item input');
//     const mediaImages = document.querySelectorAll(
//       "product-gallery .product-gallery__media img",
//     );
//     const mediaCarousel = document.querySelector(
//       "product-gallery media-carousel",
//     );
//     const mediaCursor = document.querySelector(
//       "product-gallery .product-gallery__cursor",
//     );
//     const scrollImage = document.querySelectorAll(
//       "product-gallery scroll-shadow img",
//     );
//     const shipInfo = document.querySelectorAll(".product-info-shipping .yg-shipping-time");
//     const shipInfoNew = document.querySelectorAll(".sticky-bar__ship .yg-shipping-time");
//     let first = false;
//     let firstMatchFoundFirst = false;
//     let firstMatchFound = false;
//     let index = 0;
//     thumbNail.forEach((thumbnail, i) => {
//       thumbnail.setAttribute("aria-current", "false");
//     });
//     if (optionInput[0].checked) {
//       let optionFirst = optionBtn[0].querySelector("img");
//       mediaImages.forEach((mediaImg) => {
//         const imgDataAlt = mediaImg.getAttribute('data-alt');
//         if (imgDataAlt !== null && (imgDataAlt === optionFirst.alt || imgDataAlt.indexOf('#') === -1)) {
//           if (!first && imgDataAlt === optionFirst.alt) {
//             mediaImg.parentElement.classList.add("is-selected");
//             first = true;
//           }
//           showMedia(mediaImg);
//         } else {
//           hideMedia(mediaImg);
//         }
//       });
//       let firstMatchFoundFirst = false;

//       scrollImage.forEach((img, index) => {
//         const imgDataAlt = img.getAttribute('data-alt');
//         if ( imgDataAlt !== null && (imgDataAlt === optionFirst.alt || imgDataAlt.indexOf('#') === -1)) {
//           showElement(img);
//           if (!firstMatchFoundFirst && imgDataAlt === optionFirst.alt) {
//             setThumbAttribute(index);
//             firstMatchFoundFirst = true;
//           }
//           scrollToThumbnail(index);
//         } else {
//           hideElement(img);
//         }
//       });
//     }
//     optionBtn.forEach((button, index) => {
//       button.addEventListener("click", (event) => {
//         let imgAlt = event.target.alt;
//         let firstMatchFoundFirstTrue = false;
//         let firstMatchFoundTrue = false;
//         if (shipInfo.length > 0) {
//           shipInfo.forEach((info) => {
//             info.classList.remove("active");
//           })
//           shipInfo[index].classList.add("active");
//         }
//         if (shipInfoNew.length > 0) {
//           shipInfoNew.forEach((info) => {
//             info.classList.remove("active");
//           })
//           shipInfoNew[index].classList.add("active");
//         }
//         mediaImages.forEach((img, index) => {
//           const imgDataAlt = img.getAttribute('data-alt');
//           if ( imgDataAlt !== null && (imgDataAlt === event.target.alt || imgDataAlt.indexOf('#') === -1)) {
//             if (!firstMatchFoundFirstTrue && imgDataAlt === event.target.alt) {
//               img.parentElement.classList.add("is-selected");
//               firstMatchFoundFirstTrue = true;
//             }
//             showMedia(img);
//           } else {
//             hideMedia(img);
//           }
//         });
//         thumbNail.forEach((thumbnail, i) => {
//           thumbnail.setAttribute("aria-current", "false");
//         });
//         scrollImage.forEach((img, index) => {
//           const imgDataAlt = img.getAttribute('data-alt');
//           if ( imgDataAlt !== null && (imgDataAlt === event.target.alt || imgDataAlt.indexOf('#') === -1)) {
//             showElement(img);
//             if (!firstMatchFoundTrue && imgDataAlt === event.target.alt) {
//               setThumbAttribute(index);
//               firstMatchFoundTrue = true;
//             }
//             scrollToThumbnail(index);
//           } else {
//             hideElement(img);
//           }
//         });
//       });
//     });

//     function showElement(ele) {
//       ele.parentElement.removeAttribute("hidden");
//     }

//     function hideElement(ele) {
//       ele.parentElement.setAttribute("hidden", "");
//     }

//     function showMedia(ele) {
//       ele.parentElement.classList.add("is-selected");
//       ele.parentElement.removeAttribute("hidden");
//     }

//     function hideMedia(ele) {
//       ele.parentElement.setAttribute("hidden", "");
//     }

//     function setThumbAttribute(ele) {
//       thumbNail[ele].setAttribute("aria-current", "true");
//     }

//     function scrollToThumbnail(index) {
//       const left =
//         thumbNail[index].offsetLeft -
//         pageDots.clientWidth / 2 +
//         thumbNail[index].clientWidth / 2;
//       const top =
//         thumbNail[index].offsetTop -
//         pageDots.clientHeight / 2 -
//         thumbNail[index].clientHeight / 2;
//       const behavior = window.matchMedia(
//           "(prefers-reduced-motion: no-preference)",
//         ).matches ?
//         "smooth" :
//         "auto";

//       pageDots.scrollTo({
//         left: 0,
//         top: top,
//         behavior: behavior,
//       });
//     }
//   }
// };
// 变体插件变体组